import React, { useEffect, useState } from "react";
import {
    Card,
    Input,
    Button,
    Typography,
    Select,
    Option,
} from "@material-tailwind/react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAdminGenerals, setLoaderVisibility } from "../../../app/actions/action-creators";
import axios from "axios";
import { API_BASE_URL } from '../../../data/static-config.js';
import swal from 'sweetalert';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { NavbarCMS } from "../NavbarCMS";
import EditorToolbar, { modules, formats } from "../../quill/EditorToolbar.js";

export function FormAbout() {
    const { aboutId } = useParams();
    const [lable, setLabel] = useState({});
    const [title, setTitle] = useState();
    const [subtitle, setSubtitle] = useState();
    const [hashtag, setHashtag] = useState();
    const [description, setDescription] = useState();
    const [language, setLanguage] = useState(1033);
    const [file, setFile] = useState();
    const [imgPreview, setImgPreview] = useState();
    const [overview, setOverview] = useState();
    const [history, setHistory] = useState();
    const [email, setEmail] = useState();
    const [phone, setPhone] = useState();
    const [address, setAddress] = useState();
    const [generateImg, setGenImg] = useState();

    const token = useSelector((state) => state?.combineReducer?.adminToken?.token);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (aboutId) {
            dispatch(setLoaderVisibility(true))
            setLabel({
                title: "Update About us Data",
                subtitle: "Enter your data details for update data",
                buttonLabel: "Update Data"
            })
            axios.get(`${API_BASE_URL}/api/about/${aboutId}`, { headers: { access_token: token } }).then(({ data }) => {
                dispatch(setLoaderVisibility(false))
                setAddress(data.data.address);
                setEmail(data.data.email);
                setPhone(data.data.phone);
                setHashtag(data.data.hashtag);
                setTitle(data.data.title);
                setSubtitle(data.data.subtitle);
                setDescription(data.data.description);
                setOverview(data.data.overview);
                setHistory(data.data.history);
                setImgPreview(data.data.imgBanner);
                setLanguage(data.data.languageCode);
                generateImgPreview();
            }).catch((e) => {
                dispatch(setLoaderVisibility(false))
            })
        } else {
            setLabel({
                title: "Add About us Data",
                subtitle: "Enter your data details for add data",
                buttonLabel: "Add Data"
            });
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(setLoaderVisibility(true))
        const reqParams = new FormData()
        reqParams.append("title", title);
        reqParams.append("subtitle", subtitle);
        reqParams.append("hashtag", hashtag);
        reqParams.append("description", description);
        reqParams.append("overview", overview);
        reqParams.append("history", history);
        reqParams.append("languageCode", language);
        reqParams.append("email", email);
        reqParams.append("phone", phone);
        reqParams.append("address", address);
        reqParams.append("file", file);

        if (aboutId) {
            axios
                .put(`${API_BASE_URL}/api/about/${aboutId}`, reqParams, {
                    headers: {
                        access_token: token
                    }
                })
                .then(({ data }) => {
                    const res = {
                        lst: data.data.data,
                        link: `/cms/about`
                    }
                    dispatch(setAdminGenerals(res));
                    dispatch(setLoaderVisibility(false))
                    swal("Data updated", "", "success").then((_) => {
                        navigate("/cms/about");
                    });
                })
                .catch((e) => {
                    dispatch(setLoaderVisibility(false))
                })
        } else {
            axios
                .post(`${API_BASE_URL}/api/about`, reqParams, {
                    headers: {
                        access_token: token
                    }
                })
                .then(({ data }) => {
                    dispatch(setLoaderVisibility(false))
                    swal("Data created", "", "success").then((_) => {
                        navigate("/cms/about");
                    });
                })
                .catch((e) => {
                    dispatch(setLoaderVisibility(false))
                })
        }
    };

    function handleChangeFile(e) {
        setFile(e.target.files[0]);
        setImgPreview(e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : null);
        generateImgPreview();
    }

    const handleRemove = () => {
        setFile(null);
        setImgPreview(null);
    }

    const generateImgPreview = () => {
        imgPreview ? setGenImg("w-full h-80 rounded") : setGenImg("");
    }

    return (
        <div className="w-full">
            <NavbarCMS module={lable?.title} />
            <Card color="transparent" shadow={false} className="h-full w-full flex justify-center items-center p-4">
                <Typography variant="h4" color="blue-gray">
                    {lable?.title}
                </Typography>
                <Typography color="gray" className="mt-1 font-normal">
                    {lable.subtitle}
                </Typography>
                <form className="mt-8 mb-2" onSubmit={(e) => handleSubmit(e)}>
                    <div className="mb-1 flex flex-col gap-6">
                        <div className="flex gap-2">
                            <Input
                                label="Title"
                                size="lg"
                                className="pr-20"
                                containerProps={{
                                    className: "min-w-0",
                                }}
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                            <Input
                                type="email"
                                label="Email"
                                size="lg"
                                className="pr-20"
                                containerProps={{
                                    className: "min-w-0",
                                }}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Input
                                type="text"
                                label="Phone Number"
                                size="lg"
                                className="pr-20"
                                containerProps={{
                                    className: "min-w-0",
                                }}
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                            <Input
                                size="lg"
                                label="#hashtag"
                                className="pr-20"
                                containerProps={{
                                    className: "min-w-0",
                                }}
                                value={hashtag}
                                onChange={(e) => setHashtag(e.target.value)}
                            />
                        </div>
                        <div className="flex gap-2">
                            <Select value={language} onChange={(e) => setLanguage(e)} defaultValue={language} label="Language">
                                <Option value={1033} aria-label="English">English</Option>
                                <Option value={1045} aria-label="Bahasa Indonesia">Bahasa Indonesia</Option>
                            </Select>
                            <Input
                                size="lg"
                                label="Address"
                                className="pr-20"
                                containerProps={{
                                    className: "min-w-0",
                                }}
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                            <div className="relative flex w-full max-w-[28rem]">
                                <Input size="lg" placeholder="Content" type="file" label="Image"
                                    className="pr-20" onChange={handleChangeFile}
                                    containerProps={{
                                        className: "min-w-0",
                                    }}
                                />
                                <Button
                                    size="sm"
                                    color={file ? "gray" : "blue-gray"}
                                    disabled={!file}
                                    className="!absolute right-1 top-1 rounded"
                                    onClick={handleRemove}
                                >
                                    Remove
                                </Button>
                            </div>
                        </div>
                        <div className="flex flex-col w-full justify-center items-center">
                            <img src={imgPreview} className={generateImg} />
                        </div>
                        <div className="">
                            <Typography variant="h6" color="blue-gray" className="mb-1">
                                Subtitle
                            </Typography>
                            <ReactQuill theme="snow" value={subtitle} onChange={setSubtitle} />
                        </div>
                        <div className="">
                            <Typography variant="h6" color="blue-gray" className="mb-1">
                                Description
                            </Typography>
                            <ReactQuill theme="snow" value={description} onChange={setDescription} />
                        </div>
                        <div className="">
                            <Typography variant="h6" color="blue-gray" className="mb-1">
                                Overview
                            </Typography>
                            <EditorToolbar toolbarId={'ov1'} />
                            <ReactQuill theme="snow" value={overview} onChange={setOverview} placeholder={"Write something awesome..."} modules={modules('ov1')} formats={formats} />
                        </div>
                        <div className="">
                            <Typography variant="h6" color="blue-gray" className="mb-1">
                                History
                            </Typography>
                            <EditorToolbar toolbarId={'ht1'} />
                            <ReactQuill theme="snow" value={history} onChange={setHistory} placeholder={"Write something awesome..."} modules={modules('ht1')} formats={formats} />
                        </div>
                    </div>
                    <Button className="mt-6" fullWidth type="submit">
                        {lable?.buttonLabel}
                    </Button>
                </form>
            </Card>
        </div>

    );
}